import {
  Component,
  OnInit
} from '@angular/core';
import {
  DepartmentBase
} from '../department.base';

@Component({
  selector: 'dpto-13',
  templateUrl: './dpto13.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto13Component extends DepartmentBase {
  municipalities = [{
    "id": 150,
    "code": "13001",
    "name": "Cartagena",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 151,
    "code": "13006",
    "name": "Ach\u00ed",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 152,
    "code": "13030",
    "name": "Altos del Rosario",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 153,
    "code": "13042",
    "name": "Arenal",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 154,
    "code": "13052",
    "name": "Arjona",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 155,
    "code": "13062",
    "name": "Arroyohondo",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 156,
    "code": "13074",
    "name": "Barranco de Loba",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 157,
    "code": "13140",
    "name": "Calamar",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 158,
    "code": "13160",
    "name": "Cantagallo",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 159,
    "code": "13188",
    "name": "Cicuco",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 160,
    "code": "13212",
    "name": "C\u00f3rdoba",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 161,
    "code": "13222",
    "name": "Clemencia",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 162,
    "code": "13244",
    "name": "El Carmen de Bol\u00edvar",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 163,
    "code": "13248",
    "name": "El Guamo",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 164,
    "code": "13268",
    "name": "El Pe\u00f1\u00f3n",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 165,
    "code": "13300",
    "name": "Hatillo de Loba",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 166,
    "code": "13430",
    "name": "Magangu\u00e9",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 167,
    "code": "13433",
    "name": "Mahates",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 168,
    "code": "13440",
    "name": "Margarita",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 169,
    "code": "13442",
    "name": "Mar\u00eda La Baja",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 170,
    "code": "13458",
    "name": "Montecristo",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 171,
    "code": "13468",
    "name": "Momp\u00f3s",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 172,
    "code": "13473",
    "name": "Morales",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 173,
    "code": "13490",
    "name": "Noros\u00ed (1)",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 174,
    "code": "13549",
    "name": "Pinillos",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 175,
    "code": "13580",
    "name": "Regidor",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 176,
    "code": "13600",
    "name": "R\u00edo Viejo (1)(3)",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 177,
    "code": "13620",
    "name": "San Crist\u00f3bal",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 178,
    "code": "13647",
    "name": "San Estanislao",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 179,
    "code": "13650",
    "name": "San Fernando",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 180,
    "code": "13654",
    "name": "San Jacinto",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 181,
    "code": "13655",
    "name": "San Jacinto del Cauca",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 182,
    "code": "13657",
    "name": "San Juan Nepomuceno",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 183,
    "code": "13667",
    "name": "San Mart\u00edn de Loba",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 184,
    "code": "13670",
    "name": "San Pablo",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 185,
    "code": "13673",
    "name": "Santa Catalina",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 186,
    "code": "13683",
    "name": "Santa Rosa",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 187,
    "code": "13688",
    "name": "Santa Rosa del Sur",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 188,
    "code": "13744",
    "name": "Simit\u00ed",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 189,
    "code": "13760",
    "name": "Soplaviento",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 190,
    "code": "13780",
    "name": "Talaigua Nuevo",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 191,
    "code": "13810",
    "name": "Tiquisio",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 192,
    "code": "13836",
    "name": "Turbaco",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 193,
    "code": "13838",
    "name": "Turban\u00e1",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 194,
    "code": "13873",
    "name": "Villanueva",
    "state": "1",
    "department_code": "13"
  }, {
    "id": 195,
    "code": "13894",
    "name": "Zambrano",
    "state": "1",
    "department_code": "13"
  }]
}